export default __webpack_public_path__ + "static/media/cardcustom_hd.df192a45.webp";